
export const Logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('network_id');
    localStorage.removeItem('policy_id');
    localStorage.removeItem('entity_id');
    window.location.href = "/";
  }

  